import { request } from 'ice';

interface IState {
  inboundList?: [];
  outboundList?: [];
  efficiencyList?: [];
  personList?: [];
}

export default {
  state: {
    inboundList: [] as [],
    outboundList: [],
    efficiencyList: [],
    personList: [],
  },

  effects: (dispatch) => ({
    async fetchData(data) {
      // const res = await request.get('/auth/getInfo');
      // if (res.stringPermissions) {
      dispatch.home.update(data);
      // }
    },
  }),

  reducers: {
    update(prevState: any, payload: IState) {
      console.log({ ...prevState, ...payload });

      return { ...prevState, ...payload };
    },
  },
};
